import { Component, ElementRef, EventEmitter, inject, OnInit, Output, signal, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MerchantsService } from '../../core/services/merchants.service';
import { StoresService } from '../../core/services/stores.service';
import { UserService } from '../../core/services/user.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { debounceTime, filter, map, mergeMap, Observable, startWith, switchMap } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';
import { TypeaheadDirective } from 'ngx-bootstrap/typeahead';


@Component({
  selector: 'app-client-selector',
  imports: [ReactiveFormsModule, TranslatePipe, TypeaheadDirective],
  templateUrl: './client-selector.component.html',
  styleUrl: './client-selector.component.scss',
})
export class ClientSelectorComponent implements OnInit {
  @ViewChild('searchInput') searchInput?: ElementRef<HTMLInputElement>;
  @Output() selectedPatient: EventEmitter<any> = new EventEmitter<any>();

  private formBuilder = inject(FormBuilder);
  form!: FormGroup;

  public merchantsService = inject(MerchantsService);
  private storesService = inject(StoresService);
  private userService = inject(UserService);

  public currentMerchant = toSignal(this.merchantsService.activeMerchant, { initialValue: null });
  public currentStore = toSignal(this.storesService.getActiveStore());

  public submitAttempted = signal<boolean>(false);

  public typeaheadLoading;

  public searchClients: Observable<any>;

  public noResults = false;

  ngOnInit() {
    this.form = this.formBuilder.group({
      searchValue: ['', [Validators.required]],
    });

    this.searchClients = new Observable((observer: any) => {
      observer.next(this.form.get('searchValue').value);
    }).pipe(
      filter((token) => (token ? true : false)),
      debounceTime(300),
      mergeMap((token: string) => this.doSearchClients(token))
    );
  }

  doSearchClients(query) {
    const payload = {
      name: query,
      storeId: this.currentStore()?.id,
      includeCustomFields: false,
    };
    // this.loading = false;
    if (this.currentMerchant().id) {
      return this.merchantsService.searchClients(this.currentMerchant()?.id, payload).pipe(
        map((res) => {
          return res.map((v) => ({ ...v, fullName: `${v.firstName} ${v.lastName ?? ''}` }));
        })
      );
    }
    return [];
  }

  typeaheadOnSelect(event) {
    const patient = event?.item;
    if (patient) {
      // If a patient is selected from autocomplete, emit immediately
      this.selectedPatient.emit(patient);
    } else if (this.form.value.searchValue?.length) {
      // If no patient is selected but there's a search value, create a new patient with just the name
      const newPatient = { name: this.form.value.searchValue };
      this.selectedPatient.emit(newPatient);
    }
  }

  getCurrentSearchValue(): string {
      return this.form.value.searchValue || '';
  }

  canShowClientContacts(): boolean {
    return this.userService.canShowClientContacts(this.currentStore());
  }
}
